import { render, staticRenderFns } from "./PartnerView.vue?vue&type=template&id=5dfb2791&"
import script from "./PartnerView.vue?vue&type=script&lang=js&"
export * from "./PartnerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports